import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from "@angular/router";
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { MatIconModule } from '@angular/material/icon';
import { AppModule } from '../../app.module';
import { AuthService } from '@app/services';

declare const $: any;
declare interface RouteInfo {
    path: string;
    title: string;
    icon: string;
    class: string;
    licItem: string;
}

export const ROUTES: RouteInfo[] = [
  { path: '/horas', title: 'Folha Horas',  icon:'schedule', class: '', licItem: '' },
//   { path: '/aplicacoes', title: 'Aplicações',  icon:'settings', class: '', licItem: '' },
//   { path: '/tipostarefa', title: 'Tipos Tarefa',  icon:'settings', class: '', licItem: '' },
  { path: '/concursos', title: 'Concursos',  icon:'settings', class: '', licItem: '' },
  { path: '/utilizadores', title: 'Utilizadores',  icon:'people', class: '', licItem: '' },
  // { path: '/licenca', title: 'Licenças',  icon:'key', class: '', licItem: '' },
];



@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  menuItems: any[];
  routes: RouteInfo[] = ROUTES;

  constructor(route: ActivatedRoute,
             private authService: AuthService) {

    route.params.subscribe(params => console.log("side menu id parameter",params['id']));

   }

  ngOnInit() {
  }
  isMobileMenu() {
      if ($(window).width() > 991) {
          return false;
      }
      return true;
  }

  showRoute(route: RouteInfo) {
    if (route.path == '' || route.licItem == '') {
      return true;
    }

    // check license items
    let items: string[] = this.authService.licitemsValue;
    // console.log('showroute.' + route.licItem, items);
    return items.includes(route.licItem);
  }

}
